import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Observable } from 'rxjs';
import { LibraryService } from 'src/app/core/services/library/library.service';
import { InputSearchComponent } from 'src/app/shared/components/input-search/input-search.component';
import { ProfessionalWizard } from 'src/app/shared/models/professional-wizard.model';
import { AppointmentWizardSettingsQuery } from 'src/app/shared/state/appointment-wizard-settings/appointment-wizard-settings.query';
import {
    ProfessionalServiceGroupSelected,
    ServicesGroup,
} from 'src/app/shared/state/services-group/services-group.model';
import { ServicesGroupQuery } from 'src/app/shared/state/services-group/services-group.query';

@Component({
    selector: 'app-professional-list',
    templateUrl: './professional-list.component.html',
    styleUrls: ['./professional-list.component.scss'],
})
export class ProfessionalListComponent implements OnInit {
    @Input() servicesGroups: ServicesGroup[];
    @Input() appDelegate: boolean;
    /** Flowwwer template */
    @Input() servicesGroup: ServicesGroup; //Para template Flowwwer, en la que esta vista actúa un poquito
    @Input() showServiceGroupInfo: boolean;
    @Input() step: number;
    @Input() totalStep;

    @Output() professionalClickedSingleGroupEvent = new EventEmitter<
        ProfessionalServiceGroupSelected
    >();
    @Output() professionalClickedMultipleGroupEvent = new EventEmitter<
        ProfessionalServiceGroupSelected
    >();
    /** Flowwwer template */
    @Output() professionalSelectedEvent = new EventEmitter<
        ProfessionalServiceGroupSelected
    >();
    @ViewChild(InputSearchComponent) inputSearch: InputSearchComponent;

    modelSelect: string[] = [];
    professionalAnyone: ProfessionalWizard = {
        id: '',
        description: '',
        clinic: [],
        disabled: false
    };
    professionals$: Observable<ProfessionalWizard[]>;
    ios: boolean;
    /** Flowwwer template */
    professionalsFiltered: ProfessionalWizard[];

    constructor(
        private servicesGroupQuery: ServicesGroupQuery,
        private libraryService: LibraryService,
        private appointmentWizardSettingsQuery: AppointmentWizardSettingsQuery,
        private platform: Platform
    ) {}

    ngOnInit(): void {
        this.ios = this.platform.is('ios');
        this.professionals$ = this.appointmentWizardSettingsQuery.select(
            'professionals'
        ); // TODO: Creo que no se usa en ninguna plantilla
        this.servicesGroupQuery
            .selectAll()
            .subscribe((servicesGroups: ServicesGroup[]) => {
                this.modelSelect = [];
                if (servicesGroups.length > 1) {
                    servicesGroups.forEach((servicesGroup, index) => {
                        this.modelSelect[index] = servicesGroup
                            .professionalSelected?.id
                            ? servicesGroup.professionalSelected?.id
                            : '';
                    });
                }
            });

        this.professionalAnyone.id = '0';
        this.professionalAnyone.description = this.libraryService.getLabel(
            'app_user_anyone'
        );

        /** Flowwwer template */
        this.professionalsFiltered = this.servicesGroup?.professionals;
    }

    onProfessionalClickedSingleGroup(
        professional: ProfessionalWizard,
        servicesGroupId: string
    ) {
        this.professionalClickedSingleGroupEvent.emit({
            professional,
            servicesGroupId,
        });
    }

    onProfessionalClickedMultipleGroup(event, servicesGroup: ServicesGroup) {
        let professionalSelected: ProfessionalWizard;

        if (event.target.value === '0') {
            professionalSelected = {
                id: '0',
                description: this.libraryService.getLabel('app_user_anyone'),
                clinic: [],
                disabled: false,
            };
        } else {
            const professionalsServicesGroup = servicesGroup.professionals;
            professionalsServicesGroup.forEach((currentProfessional) => {
                if (currentProfessional.id === event.target.value) {
                    professionalSelected = currentProfessional;
                }
            });
        }

        this.professionalClickedMultipleGroupEvent.emit({
            professional: professionalSelected,
            servicesGroupId: servicesGroup.id,
        });
    }

    /** Flowwwer template */
    onProfessionalSelected(
        professional: ProfessionalWizard,
        servicesGroupId: string
    ) {
        this.professionalSelectedEvent.emit({
            professional,
            servicesGroupId,
        });
    }

    onProfessionalSearch(searchText: string): void {
        this.professionalsFiltered = this.servicesGroup.professionals.filter(
            (professional: ProfessionalWizard) => {
                return professional.description
                    .toLowerCase()
                    .includes(searchText.toLowerCase());
            }
        );
    }
}
